import { Db } from '@diamond/shared/schema';

const ADMIN_UI_ROLES: ReadonlyArray<Db['users']['role']> = [
  'super_admin',
  'admin',
  'cs_katalog',
  'cs_cabang',
  'collector',
];

export function canAccessAdminUi(role: string): boolean {
  return ADMIN_UI_ROLES.some((allowedRole) => allowedRole === role);
}
